import { Directive, TemplateRef } from '@angular/core';
import { SgToasterItemTemplateContext } from './toaster.component';
import { SgToasterService } from './toaster.service';

@Directive({
  selector: '[sgToasterDef]',
  standalone: false,
})
export class SgToasterDefDirective {
  constructor(
    private tRef: TemplateRef<SgToasterItemTemplateContext>,
    private toasterService: SgToasterService
  ) {
    this.toasterService.toasterTemplateRef = this.tRef;
  }
}
